var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFencing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5657 71.4817L36.3029 73.3986L29.4203 83.228C28.9872 83.846 28.1339 83.9967 27.5165 83.5637L27.0188 83.2149C26.4007 82.7824 26.25 81.9291 26.6832 81.3111L33.5657 71.4817Z",
    fill: "#592EE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9566 68.442C29.7513 64.4502 35.2609 63.479 39.2527 66.2737C43.244 69.0683 44.2158 74.578 41.4206 78.5691",
    fill: "#592EE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2246 78.3548L40.5519 77.8882L41.485 78.5404L41.1594 79.0073C40.098 80.526 38.6233 81.7097 36.9088 82.4123C35.2528 83.094 33.4371 83.2917 31.6727 82.9835C30.3436 82.7492 29.0802 82.2258 27.9751 81.4506L27.509 81.1233L28.1627 80.1888L28.6291 80.5178C29.5989 81.196 30.7052 81.6556 31.8707 81.8611C33.4219 82.1317 35.0182 81.9567 36.4746 81.3585C37.9876 80.7379 39.2894 79.6943 40.2247 78.3548L40.2246 78.3548Z",
    fill: "#592EE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7496 21.5516L69.7495 21.5517L38.7933 65.7628C38.5813 66.0655 38.6544 66.4833 38.9572 66.6956C39.26 66.9079 39.6777 66.8345 39.8899 66.5315L70.8461 22.3205C70.8461 22.3204 70.8461 22.3204 70.8461 22.3204C71.0584 22.0177 70.9853 21.5998 70.6824 21.3875C70.3796 21.1751 69.9618 21.249 69.7496 21.5516Z",
    fill: "#592EE5",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7995 71.4817L68.0623 73.3986L74.9449 83.228C75.3781 83.846 76.2313 83.9967 76.8487 83.5637L77.3464 83.2149C77.9645 82.7824 78.1152 81.9291 77.6821 81.3111L70.7995 71.4817Z",
    fill: "#592EE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4086 68.442C74.6139 64.4502 69.1043 63.479 65.1125 66.2737C61.1212 69.0683 60.1494 74.578 62.9446 78.5691",
    fill: "#592EE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1406 78.3548L63.8133 77.8882L62.8802 78.5404L63.2058 79.0073C64.2672 80.526 65.7419 81.7097 67.4564 82.4123C69.1124 83.094 70.9281 83.2917 72.6925 82.9835C74.0216 82.7492 75.285 82.2258 76.3901 81.4506L76.8561 81.1233L76.2024 80.1888L75.7361 80.5178C74.7663 81.196 73.66 81.6556 72.4945 81.8611C70.9433 82.1317 69.347 81.9567 67.8906 81.3585C66.3776 80.7379 65.0758 79.6943 64.1405 78.3548L64.1406 78.3548Z",
    fill: "#592EE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6156 21.5516L34.6157 21.5517L65.5719 65.7628C65.7839 66.0655 65.7108 66.4833 65.408 66.6956C65.1052 66.9079 64.6875 66.8345 64.4753 66.5315L33.5191 22.3205C33.5191 22.3204 33.5191 22.3204 33.5191 22.3204C33.3068 22.0177 33.3799 21.5998 33.6828 21.3875C33.9856 21.1751 34.4034 21.249 34.6156 21.5516Z",
    fill: "#592EE5",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFencing);
export default __webpack_public_path__ + "static/media/Fencing.dab1c3609671c33d790442db22f2fa6d.svg";
export { ForwardRef as ReactComponent };